import { render, staticRenderFns } from "./VxTable.vue?vue&type=template&id=235a06bf"
import script from "./VxTable.vue?vue&type=script&lang=js"
export * from "./VxTable.vue?vue&type=script&lang=js"
import style0 from "./VxTable.vue?vue&type=style&index=0&id=235a06bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports